"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Geometry = exports.GeometryBase = void 0;
var GeometryBase = /** @class */ (function () {
    function GeometryBase(width, height) {
        this.name = 'Base';
        this.width = Math.round(width);
        this.height = Math.round(height);
    }
    GeometryBase.prototype.serialize = function () {
        throw Error('NotImplemented');
    };
    return GeometryBase;
}());
exports.GeometryBase = GeometryBase;
var Geometry = /** @class */ (function (_super) {
    __extends(Geometry, _super);
    function Geometry(width, height) {
        var _this = _super.call(this, width, height) || this;
        _this.coordinates(width, height);
        return _this;
    }
    Geometry.prototype.coordinates = function (x, y) {
        throw Error('NotImplemented');
    };
    return Geometry;
}(GeometryBase));
exports.Geometry = Geometry;
//# sourceMappingURL=geometry-base.js.map